import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { PatientAllergyEffects } from '../allergies/data-access/store/effects/patient-allergy.effects';
import { patientAllergiesReducer } from '../allergies/data-access/store/reducer/patient-allergy.reducer';
import { AppointmentEffects } from '../appointments/store/effects/appointments.effects';
import { appointmentReducer } from '../appointments/store/reducer/appointments.reducer';
import { CareTeamEffects } from '../care-team/store/effects/care-team.effects';
import { careTeamReducer } from '../care-team/store/reducer/care-team.reducer';
import { PatientFamilyHistoryEffects } from '../family-history/data-access/store/patient-family-history/effects/patient-family-history.effects';
import { patientFamilyHistoriesReducer } from '../family-history/data-access/store/patient-family-history/reducer/patient-family-history.reducer';
import { PatientHealthConcernEffects } from '../health-concerns/data-access/store/patient-health-concern/effects/patient-health-concern.effects';
import { patientHealthConcernsReducer } from '../health-concerns/data-access/store/patient-health-concern/reducer/patient-health-concern.reducer';
import { PatientProblemEffects } from '../problems/data-access/store/patient-problem/effects/patient-problem.effects';
import { patientProblemsReducer } from '../problems/data-access/store/patient-problem/reducer/patient-problem.reducer';
import { PatientSurgicalHistoryEffects } from '../surgical-history/data-access/store/patient-surgical-history/effects/patient-surgical-history.effects';
import { patientSurgicalHistoriesReducer } from '../surgical-history/data-access/store/patient-surgical-history/reducer/patient-surgical-history.reducer';
import { ImmunizationEffects } from '../immunizations/store/effects/immunization.effects';
import { immunizationReducer } from '../immunizations/store/reducer/immunization.reducer';
import { LetterEffects } from '../letters/store/effects/letters.effects';
import { lettersReducer } from '../letters/store/reducer/letters.reducer';
import { MedicalRecordEffects } from '../medical-record/store/effects/medical-record.effects';
import { medicalRecordReducer } from '../medical-record/store/reducer/medical-record.reducer';
import { MedicationEffects } from '../medications/store/effects/medications.effects';
import { medicationReducer } from '../medications/store/reducer/medications.reducer';
import { MessagesEffects } from '../messages/store/effects/messages.effects';
import { messagesReducer } from '../messages/store/reducer/messages.reducer';
import { PatientGoalsEffects } from '../patient-goals/store/effects/patient-goals.effects';
import { patientGoalsReducer } from '../patient-goals/store/reducer/patient-goals.reducer';
import { PharmacyEffects } from '../pharmacies/store/effects/pharmacy.effects';
import { pharmacyReducer } from '../pharmacies/store/reducer/pharmacy.reducer';
import { ProfileEffects } from '../profile/store/effects/profile.effects';
import { profileReducer } from '../profile/store/reducer/profile.reducer';
import { PROXY_ACCESS_PROVIDERS } from '../proxy-access/proxy-access.providers';
import { ReportsEffects } from '../reports/store/effects/reports.effects';
import { reportsReducer } from '../reports/store/reducer/reports.reducer';
import { PatientResultsEffects } from '../results/store/effects/patient-result.effects';
import { patientResultsReducer } from '../results/store/reducer/patient-result.reducer';
import { ScreeningsEffects } from '../screenings/data-access/store/effects/screenings.effects';
import { screeningsReducer } from '../screenings/data-access/store/reducer/screenings.reducer';

export const PATIENT_FEATURE_PROVIDERS = [
  provideState({ name: 'appointment', reducer: appointmentReducer }),
  provideState({ name: 'care-team', reducer: careTeamReducer }),
  provideState({ name: 'immunization', reducer: immunizationReducer }),
  provideState({ name: 'messages', reducer: messagesReducer }),
  provideState({ name: 'patient-goals', reducer: patientGoalsReducer }),
  provideState({ name: 'patient-allergies', reducer: patientAllergiesReducer }),
  provideState({ name: 'patient-family-histories', reducer: patientFamilyHistoriesReducer }),
  provideState({ name: 'patient-health-concerns', reducer: patientHealthConcernsReducer }),
  provideState({ name: 'patient-lab-results', reducer: patientResultsReducer }),
  provideState({ name: 'patient-problems', reducer: patientProblemsReducer }),
  provideState({ name: 'patient-surgical-histories', reducer: patientSurgicalHistoriesReducer }),
  provideState({ name: 'profile', reducer: profileReducer }),
  // Shared with the public caregiver route, which is outside the patient area.
  ...PROXY_ACCESS_PROVIDERS,
  provideState({ name: 'medication', reducer: medicationReducer }),
  provideState({ name: 'medical-record', reducer: medicalRecordReducer }),
  provideState({ name: 'pharmacies', reducer: pharmacyReducer }),
  provideState({ name: 'reports', reducer: reportsReducer }),
  provideState({ name: 'letters', reducer: lettersReducer }),
  provideState({ name: 'screenings', reducer: screeningsReducer }),
  provideEffects([
    AppointmentEffects,
    CareTeamEffects,
    ImmunizationEffects,
    MessagesEffects,
    PatientGoalsEffects,
    PatientAllergyEffects,
    PatientFamilyHistoryEffects,
    PatientHealthConcernEffects,
    PatientProblemEffects,
    PatientResultsEffects,
    PatientSurgicalHistoryEffects,
    ProfileEffects,
    MedicationEffects,
    PharmacyEffects,
    ReportsEffects,
    MedicalRecordEffects,
    LetterEffects,
    ScreeningsEffects,
  ]),
];
